<template>
  <div>
    <button class="gui-btn gui-btn--red gui-btn--w-230"
            @click.prevent="onCreateAccreditationClick"
            v-if="showCreateButton">{{$t('form.accreditation.create')}}</button>
    <edit-form :acc="acc" v-if="showEditForm"></edit-form>

    <div class="accreditation__warning" v-if="showWarning">
      <img src="@/assets/img/static/warning.svg" alt="">
      <div class="accreditation__text">
        <p>{{$t('form.accreditation.organization-should-be-filled-for-accreditation')}}</p>
        <router-link to="/account/contractor">{{$t('form.accreditation.create-contractor')}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import EditForm from './AccreditationViewMode';
  import Errors from '@/api/types/errors'

  export default {
    components: {
      EditForm
    },
    data: () => ({
      mode: undefined
    }),
    computed: {
      showCreateButton() {
        return this.user.permissions.CAN_CREATE_ACCREDITATION && !this.mode
      },
      showEditForm() {
        return this.permissions.CAN_EDIT_ACCREDITATION || this.permissions.CAN_VIEW_ACCREDITATION;
      },
      showWarning() {
        return !this.user.permissions.CAN_CREATE_ACCREDITATION && !this.permissions.CAN_VIEW_ACCREDITATION;
      },
      acc() {
        return this.$store.getters.currentAccreditation;
      },
      permissions() {
        return this.acc ? this.acc.permissions : {};
      },
      user() {
        return this.$store.getters.currentUser;
      }
    },
    methods: {
      onCreateAccreditationClick() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('createAccreditation');
            this.mode = 'edit'
          }
          catch(e) {
            console.error('unable to create accreditation', e);
            this.globalErrorHandler(e, {
              'ALREADY_EXISTS': 'errors.accreditation-already-exists',
              'INVALID_STATE': 'errors.contractor-is-not-fully-filled'
            });
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
